import React from 'react';

const BattleLine = ({ position, height }) => {
  return (
    <div 
      className="absolute top-0 bottom-0 border-r-4 border-yellow-500 border-dashed pointer-events-none"
      style={{ 
        left: `${position}%`,
        height: height || '100%',
        zIndex: 10
      }}
    >
      <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-black bg-opacity-75 text-yellow-500 px-2 py-1 text-xs rounded">
        {Math.round(position)}%
      </div>
    </div>
  );
};

export default BattleLine;